import { Button, Modal } from 'reactstrap';
import {
  ActivateGuest,
  GuestOfferDetails,
  GuestVisitDetails,
} from '../models/guestModel';

interface Props {
  guestId: string;
  isOpen: boolean;
  onToggle: () => void;
  onConfirmation: (data: ActivateGuest) => void;
  bodyText: string;
  confirmationText: string;
  abortText: string;
  investor: GuestVisitDetails | GuestOfferDetails;
}

export default function ActivateGuestModal({
  guestId,
  isOpen,
  onToggle,
  onConfirmation,
  bodyText,
  confirmationText,
  abortText,
  investor,
}: Props) {
  return (
    <Modal
      className="modal-dialog-centered"
      isOpen={isOpen}
      toggle={() => onToggle()}
    >
      <div className="modal-header">
        <h6 className="modal-title" id="modal-title-default">
          Confirmación de acción
        </h6>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => onToggle()}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body">
        <p>{bodyText}</p>
      </div>
      <div className="modal-footer">
        <Button
          color="primary"
          type="button"
          onClick={() =>
            onConfirmation({
              customerInfo: investor,
              guestId: guestId,
            })
          }
        >
          {confirmationText}
        </Button>
        <Button
          className="ml-auto"
          color="link"
          data-dismiss="modal"
          type="button"
          onClick={() => onToggle()}
        >
          {abortText}
        </Button>
      </div>
    </Modal>
  );
}
